import C from "classnames";
import * as React from "react";
import { ReactComponent as Icon } from "packages/component-library/src/img/rc_loading_icon.svg";
import Fade from "../../Utilities/Fade";
const positionMapper = {
    absolute: "position-absolute",
    relative: "position-relatie",
    fixed: "position-fixed",
};
const sizeMapper = {
    sm: "50px",
    lg: "120px",
};
export const LoadingIcon = (props) => {
    return (React.createElement(Fade, { remove: true, in: props.loading, timeout: 150 },
        React.createElement("div", { className: C("loading-icon-container", "d-flex", "justify-content-center", "align-items-center", props.position && positionMapper[props.position], "absolute-full-width", "absolute-full-height") },
            props.backdrop && (React.createElement("div", { className: C("position-absolute", "absolute-full-width", "absolute-full-height", "bg-dark", "backdrop", "rounded") })),
            React.createElement(Icon, { className: "loading-icon", height: props.size ? sizeMapper[props.size] : "80px", width: props.size ? sizeMapper[props.size] : "80px" }))));
};
//# sourceMappingURL=LoadingIcon.js.map